import {
  Flex,
  ReportSection,
  ReportSectionItemContent,
  ReportSectionItemTable,
} from '@/components';
import type { ProjectModel } from '@/features/project/projects/_models/project';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import type z from 'zod';

type Props = {
  project: z.infer<typeof ProjectModel>;
};
export const RingkasanProgram: FC<Props> = ({ project }) => {
  const { t } = useTranslation();
  return (
    <ReportSection
      title={t('project-Ringkasan-Program')}
      items={[
        {
          indexText: '9.',
          subtitle: t('project-task'),
          item: <ReportSectionItemContent value={project.task} />,
        },
        {
          indexText: '10.',
          subtitle: t('project-purpose'),
          item: <ReportSectionItemContent value={project.purpose} />,
        },
        {
          indexText: '11.',
          subtitle: t('project-target'),
          item: (
            <Flex>
              <ReportSectionItemContent value={project.indonesiaData?.target} />
              <ReportSectionItemContent
                wrapperStyle={{ flex: 2 }}
                indexText="12."
                value={
                  <ReportSectionItemTable
                    header={[
                      {
                        type: 'text',
                        value:
                          'Jumlah target penerima manfaat\n(persentase dari jumlah penduduk)',
                        textStyle: { textAlign: 'center' },
                        ratio: 100,
                        colSpan: 6,
                      },
                    ]}
                    data={
                      project.indonesiaData?.jumlahTargetPenerimaManfaat?.map(
                        (item) => {
                          return {
                            row: [
                              {
                                type: 'text',
                                value: item.elementValue,
                                align: 'right',
                              },
                              {
                                type: 'text',
                                value: item.elementUnit,
                                align: 'right',
                              },
                              {
                                type: 'text',
                                value: item.element2Value,
                                align: 'right',
                              },
                              {
                                type: 'text',
                                value: item.element2Unit,
                                align: 'right',
                              },
                              {
                                type: 'text',
                                value: item.ratio,
                                align: 'right',
                              },
                              {
                                type: 'text',
                                value: t('percentage-unit'),
                                align: 'right',
                              },
                            ],
                          };
                        },
                      ) ?? []
                    }
                  />
                }
                hasLeftBorder
              />
            </Flex>
          ),
        },
        {
          indexText: '13.',
          subtitle: t('project-overview'),
          item: <ReportSectionItemContent value={project.overview} />,
        },
        {
          indexText: '14.',
          subtitle: t('related-projects'),
          item: (
            <ReportSectionItemContent
              value={project.relatedProjects.map((v) => v.name).join('\n')}
            />
          ),
        },
      ]}
    />
  );
};
